export default {
    job: {
        seekers: 'کارجویان',
    },
};
